<template>
    <div class="pb-4 relative">
        <div class="wrapper-input"
            :class="[isError ? 'error' : 'active']">
            <div ref="dropdown-btn">
                <div class="input-data" @click="toggleDropdown()">
                    <div v-if="!itemSelected" class="ic-dropdown">
                        <img  src="@/assets/img/flag-malaysia.svg" alt="">  
                        <div>
                            <img class="ml-2" src="@/assets/icon/ic-arrow-down-black.svg" alt="">
                        </div>
                        <div class="line-custom"></div>
                    </div>
                    <span v-if="itemSelected" class="ic-dropdown">
                        <div v-if="itemSelected.text == 'malaysia' ">
                            <img src="@/assets/img/flag-malaysia.svg" alt="">
                        </div>
                        <div v-if="itemSelected.text == 'singapore' ">
                            <img src="@/assets/img/flag-singapore.svg" alt="">
                        </div>
                        <div>
                            <img class="ml-2" src="@/assets/icon/ic-arrow-down-black.svg" alt="">
                        </div>
                        <div class="line-custom"></div>
                    </span>
                </div>
            </div>
            <div v-show="showList && itemList.length > 0"
                 ref="ddl-list-area"
                 class="dropdown-input-custom">
                <div class="show-input-custom">
                    <div v-for="(v) in itemList" :key="v.text"
                        @click="selectItem(v)" :class="[v.value == itemList.length-1? 'mt-2' : 'line',  v.value == 0 ? 'mt-0':'']">
                        <div v-if="v.text == 'malaysia'">
                            <img class="mb-2" src="@/assets/img/flag-malaysia.svg" alt="" @click="onCheckFlag()">
                        </div>
                        <div v-if="v.text == 'singapore'">
                            <img src="@/assets/img/flag-singapore.svg" alt="" @click="onCheckFlag()">
                        </div>
                    </div>
                    
                </div>
            </div>
            <input type="tel"
                :id="inputId"
                class="input-data-custom"
                v-model="content"
                :maxlength="inputMaxLength"
                @input="onChange()"
                @focus="onFocus(true)"
                @blur="onFocus(false)">
            <label :for="inputId"
                class="title-label-custom"
                :class="[{'transition-label-no-content': !content && !focusText},
                        {'transition-label-content': content || focusText},
                        ]"
            >{{inputLbl.name}}</label>
        </div>
        <div class="text-error" v-if="!errorInfo.isValid"
             v-show="!errorInfo.isValid">{{errorInfo.msg}}
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Boolean} isTextOnly (optional) Only text.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputText",
    props: {
        // v-model
        value:     { type: String },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        isTextOnly:     { type: Boolean, default: false },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
        itemList:       { type: Array, required: true },
        selectedFromCache: { type: Array, required: false }
    },
    data: function() {
        return {
            inputId: '',
            content: this.value,
            inputMaxLength: null,
            focusText: false,
            showList: false,
            itemSelected: null,
            countryCode: 'malaysia',
            type: ''
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        // getErrorMsg: function() {
        //     return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
        //         ? this.errorInfo.msg
        //         : '';
        // },
    },
    created: function () {
        let randId = Math.floor(Math.random() * 100000);
        this.inputId = 'contact-number-' + randId;

        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
        this.countryCode = 'malaysia';
    },
    mounted: function() {
        this.setSelectedDropdown();
        this.validateInput();
    },
    methods: {
        setSelectedDropdown: function() {
            let item = this.itemList.find((obj) => {
                return obj.value == this.content;
            });
            
            if (item != null) {
                this.itemSelected = item;
            }

            if (this.selectedFromCache) {
                this.selectedFromCache.find((obj) => {
                    this.itemSelected = obj;
                    this.countryCode = obj.text;
                    console.log(this.countryCode);
                })
            }
        },
        toggleDropdown: function() {
            if (this.showList) {
                this.closeDropdown();
            } else {
                this.openDropdown();
            }
        },
        openDropdown: function() {
            this.isBottomDropdown = true;
            this.showList = true;
            document.addEventListener('click', this.documentClick);

            this.$nextTick(() => {
                let elem = this.$refs['ddl-list-area'];
                let bottom = elem.getBoundingClientRect().bottom;
                let windowHeight = window.innerHeight;

                this.isBottomDropdown = bottom < windowHeight;
            });
        },
        closeDropdown: function() {
            this.showList = false;
            document.removeEventListener('click', this.documentClick);
        },
        documentClick: function(e) {
            let el = this.$refs['dropdown-btn'];
            var target = e.target;

			if (el !== target && !el.contains(target)) {
				this.closeDropdown();
			}
        },
        selectItem: function(item) {
            this.countryCode = item.text;
            this.itemSelected = item;
            this.closeDropdown();

            this.validateInput();
            this.$emit('countryCode', this.countryCode);
        },

        clearSelect: function() {
            this.content = "";
            this.itemSelected = null;
            this.countryCode = "";
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },
        setValue: function(value) {
            this.content = value;
            this.setSelectedDropdown();
            this.validateInput();
        },
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
            // invalid format
            if (this.inputLbl.invalid && this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.invalid);
                return;
            }
        },
        checkFlag: function () {
            if (this.countryCode == 'malaysia') {
                this.inputMaxLength = 11;
            } else {
                this.inputMaxLength = 8;
            }
        },
        onCheckFlag: function() {
            this.content = '';
        },
        onChange: function() {
            var result = this.content;
            this.checkFlag();
            const check = result.charAt(0);
            if (this.countryCode == 'malaysia') {
                if (check != 0) {
                    result = '';
                    this.validateInput();
                }
            } else {
               if (check != 8 && check != 9) {
                    result = '';
                    this.validateInput();
               }
            }

            if (this.isTextOnly) {
                result = RegxHelper.removeEmoji(result);
                result = RegxHelper.removeNumber(result);
                result = RegxHelper.removeSymbol(result);
            }
            
            result = RegxHelper.removeNotNumber(result);
            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result, result);
        },
        onFocus: function(focus) {
            this.focusText = focus;
        },
    },
}
</script>
<style lang="scss" scoped>
   @import "@/style/Input/InputDropdown.scss";
   .wrapper-input {
        z-index: 10;
   }
</style>
